@if (showLoader) {
  <app-loader variant="analyzing"></app-loader>
} @else if (error) {
  <div class="error-container">
    <div class="error-content">
      @if (errorCode === 404) {
        <h1>{{ 'initialResults.error.notFoundTitle' | translate }}</h1>
      } @else if (errorCode === 500) {
        <h1>{{ 'initialResults.error.serverTitle' | translate }}</h1>
      } @else {
        <h1>{{ 'initialResults.error.genericTitle' | translate }}</h1>
      }
      <p>{{ error }}</p>
      <button mat-raised-button color="primary" (click)="navigateToDashboard()">{{ 'initialResults.error.returnToDashboard' | translate }}</button>
    </div>
  </div>
} @else {
  <main class="container">
    <div><h2>{{ 'initialResults.heading' | translate }}</h2></div>
    <div class="subtitle">
       {{ 'initialResults.subtitle' | translate }}
    </div>

    <div class="results-container">
      <div class="image-grid">
        <div class="image-container">
          @if(processedImages.front){
            <div class="image-wrapper">
              <img [src]="processedImages.front" [attr.alt]="'initialResults.frontViewAlt' | translate" />
            </div>
          }
        </div>
      </div>
      <div class="full-analysis">
        <div class="section-title"><span class="bright-pink">{{ 'initialResults.fullAnalysis.titlePrefix' | translate }}</span> {{ 'initialResults.fullAnalysis.titleSuffix' | translate }}</div>
        <div class="analysis-feature">
          <div>
            <div class="feature-icon">
              <img src="../../assets/images/search.png" alt="" />
            </div>
          </div>
          <span>{{ 'initialResults.fullAnalysis.feature1' | translate }}</span>
        </div>
        <div class="analysis-feature">
          <div>
            <div class="feature-icon">
              <img src="../../assets/images/doctor-icon.png" alt="" />️
            </div>
          </div>
          <span>{{ 'initialResults.fullAnalysis.feature2' | translate }}</span>
        </div>
        <div class="analysis-feature">
          <div>
            <div class="feature-icon">
              <img src="../../assets/images/idea.png" alt="" />
            </div>
          </div>
          <span>{{ 'initialResults.fullAnalysis.feature3' | translate }}</span>
        </div>
      </div>

      <div class="pricing-card">
        <app-price></app-price>
        <div class="button-row">
          <app-unlock-button
            [isProcessing]="isProcessing"
            (click)="createCheckoutSession();"
          ></app-unlock-button>
        </div>
        <div class="text">
          <h2>{{ 'initialResults.sampleReport.title' | translate }}</h2>
          <p>{{ 'initialResults.sampleReport.description' | translate }}</p>
        </div>
        <div class="image-row">
          <div class="image-result-container">
             <img src="../../assets/images/peritale-result.png"/>
          </div>
        </div>
      </div>
    </div>
  </main>
}
